import React, { useEffect, useState } from 'react'
import {
  Button,
  Col,
  Table,
  Image,
  Form,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
  InputGroup
} from 'react-bootstrap'
import NavTitle from '../../../nav-title'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { getDepartmentsAPI } from '../../../../services/departments'
import {
  BsChevronLeft,
  BsChevronRight,
  BsPlusLg,
  BsSearch
} from 'react-icons/bs'
import { PAGE_SETTING, PIM_ORG_FACTION } from '../../../../router/routes'
import { PIM_ORG_TEAM } from '../../../../router/routes'
import { useDebounce } from '@react-hook/debounce'
import TextNavTitle from '../../../TextNavTitle'
import detailImg from '../../../../images/Detail.svg'
import editImg from '../../../../images/Edit.svg'
import CardCustom from '../../../custom/card-custom'
import AddAndUpdateDivision from './addUpdate'
import TableSkeletonBody from '../../../custom/TableSkeletonBody'

export default function Index() {
  let [searchParams, setSearchParams] = useSearchParams()
  const orgId = searchParams.get('orgId')
  const factionId = searchParams.get('factionId')
  const divisionId = searchParams.get('divisionId')
  const [dataTable, setdataTable] = useState([])
  const [showCreate, setShowCreate] = useState({ isShow: false, data: null })
  const navigate = useNavigate()
  const param = { orgId, divisionId, factionId }
  const [isRefresh, setIsRefresh] = useState(false)
  const divisionName = searchParams.get('nameGroup')
  const factionName = searchParams.get('nameDepartment')

  const [input, setInput] = useDebounce('', 1000)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsRefresh(false)
  }, [isRefresh])

  useEffect(() => {
    if (!orgId && !divisionId && !factionId) {
      return
    } else {
    }
  }, [input])

  useEffect(() => {
    getDepartment()
    setIsRefresh(false)
  }, [isRefresh, input])

  const handleClick = (d) => {
    navigate(
      `${PIM_ORG_TEAM}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameDepartment=${factionName}&departmentId=${d.id}&nameDivision=${d.department_en}`
    )
  }

  const getDepartment = async () => {
    setIsLoading(true)
    const result = await getDepartmentsAPI({
      ...param,
      searchs: input
    })
    setIsLoading(false)
    if (!result) return
    if (result.status) {
      setdataTable(result.result)
    }
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>
          <Link
            className="link"
            style={{ color: '#7A7A7A' }}
            onClick={() => {
              navigate(-1)
            }}
          >
            <BsChevronLeft /> Department
          </Link>
        </TextNavTitle>
      </NavTitle>
      <p className="fw-normal  text-secondary">
        <Link
          className="link text-secondary "
          to={`${PAGE_SETTING}?orgId=${orgId}`}
        >
          Group:
        </Link>

        <Link
          className="link text-secondary "
          to={`${PAGE_SETTING}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}`}
        >
          {` ${divisionName}`}
        </Link>
        <Link
          className="link text-secondary"
          to={`${PIM_ORG_FACTION}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameFaction=${factionName}`}
        >
          <BsChevronRight />
          {`Division: ${factionName}`}
        </Link>
        <span className="link" style={{ color: '#C7C7C7' }}>
          <BsChevronRight /> Department
        </span>
      </p>
      <CardCustom className="h-full" border="0">
        <div className="p-3 ">
          <Col
            xl={12}
            className="my-auto d-flex gap-3 justify-content-between"
            style={{ flexWrap: 'wrap' }}
          >
            <label
              className=" my-auto fw-bold"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {dataTable.length?.toLocaleString()}
            </label>
            <div className="d-flex justify-content-end gap-2 ">
              <span style={{ minWidth: '300px' }}>
                <InputGroup>
                  <InputGroup.Text className="bg-white border-end-0  text-muted">
                    <BsSearch />
                  </InputGroup.Text>
                  <Form.Control
                    className="border-start-0 ps-0 placeholder-text"
                    placeholder="Department/ Department EN/ Department TH"
                    onChange={(e) => setInput(e.target.value)}
                  />
                </InputGroup>
              </span>
              <span>
                <Button
                  className="btn btn-primary "
                  onClick={() => setShowCreate({ isShow: true, data: null })}
                  size="lg"
                  style={{
                    minWidth: '150px'
                  }}
                >
                  <BsPlusLg /> Add Department
                </Button>
              </span>
            </div>
          </Col>
        </div>

        <Table hover>
          <thead
            className="bg-hrms text-white "
            style={{ position: 'sticky', top: '0px' }}
          >
            <tr className="font-title-table">
              <th className="fw-normal">#</th>
              <th className="fw-normal">Department</th>
              <th className="fw-normal">Department EN</th>
              <th className="fw-normal">Department TH</th>
              <th className="fw-normal text-center"> Count of Employee</th>
              <th className="fw-normal ">Cost Name</th>
              <th className="fw-normal text-center"> Action</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <TableSkeletonBody colSpan={7} rowSpan={10} />
            ) : dataTable.length > 0 ? (
              dataTable.map((d, i) => (
                <tr key={i} className="fw-light font-small-2 ">
                  <td>{i + 1}</td>
                  <td>{d.department}</td>
                  <td className="">{d.department_en}</td>
                  <td className="">{d.department_th}</td>
                  <td className="text-center">{d.count_emp}</td>
                  <td className="">{d.cost_name}</td>
                  <td className="text-center ">
                    <span className="d-flex justify-content-center">
                      <ButtonToolbar>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-detail">Detail</Tooltip>
                          }
                        >
                          <Button
                            variant="btn btn-outline-primary"
                            className="border-0 d-flex justify-content-center"
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => {
                              handleClick(d)
                            }}
                          >
                            <Image
                              src={detailImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                      <ButtonToolbar>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-detail">Edit</Tooltip>}
                        >
                          <Button
                            variant="btn btn-outline-primary"
                            className="border-0 d-flex justify-content-center"
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => {
                              // setDetailTable(d)
                              // handleEditButtonClick()
                              setShowCreate({ isShow: true, data: d })
                            }}
                          >
                            <Image
                              src={editImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                    </span>
                    {/* <BtnEditCustom
                      onClick={() => {
                        setDetailTable(d)
                        handleEditButtonClick()
                      }}
                    >
                      Edit
                    </BtnEditCustom> */}
                  </td>
                </tr>
              ))
            ) : (
              <tr className="fw-light ">
                <td colSpan={6} className="text-center">
                  - No data -
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </CardCustom>

      {showCreate.isShow && (
        <AddAndUpdateDivision
          param={{ orgId, divisionId, factionId }}
          data={showCreate.data}
          show={showCreate.isShow}
          fnGetList={() => getDepartment()}
          onCancel={() => {
            setShowCreate({ isShow: false, data: null })
          }}
        />
      )}
    </div>
  )
}
